import _ from 'lodash';
import { Pill } from '@janus.team/janus-particles';

const projectLinkedStateColor = (status) => ({
  LINKED: 'green',
  UNLINK_REQUESTED: 'red',
  UNLINKED: 'gray',
  LINK_REQUESTED: 'yellow',
}[status] || 'gray');

export const ProjectLinkedState = ({ project }) => (
  <Pill filled color={projectLinkedStateColor(project?.linkedState)}>{_.startCase(_.lowerCase(project?.linkedState))}</Pill>
);
